import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Redirect } from "react-router";

// components
import Table from '../shared/Table';
import DownloadSection from '../shared/DownloadSection';
import Header from '../shared/Header';
// styles
import * as Styled from './styles';
// utils 
import { fetchResults } from '../../utils/fetch';
//assets
import { resultsMessages as messages }  from '../../assets/messages';
import { resultInfoMessages as resultMessage }  from '../../assets/messages';

function Results({ logo }) {
  const [ results, setResults ] = useState([])
  const [ goBack, setGoBack ] = useState(false)
  const [ page, setPage ] = useState(1)
  const [ fetching, setFetching ] = useState(true)
  const [ endOfData, setEndOfData ] = useState(false)
  const [ catchedError, setCatchedError ] = useState(200)

  var url_params = ""
  var user_string = ""
  const url = '/posts?q='
  
  const location = useLocation()
  if (location.state !== undefined && location.state !== null) {
    url_params = location.state.params
    user_string = location.state.user_string
  }

  useEffect(() => {
    var unmounted = false
    if ( !unmounted ) setPage(page+1)
    return () => { unmounted = true }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results]) 

  useEffect(() => {
    var unmounted = false
    fetchResults(url+page, url_params, user_string)
      .then(res => {
        if (res === false) {
          setFetching(false)
          setEndOfData(true) 

        } else if (res === 500 || res === 503) {
          setFetching(false)
          setEndOfData(true) 
          setCatchedError(res)

        } else if ( !unmounted && res !== undefined) {
          setResults(prev => {
              return [
                ...prev,
                ...res
              ]
            }
          )
        }
      })

    return () => { unmounted = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  function handleGoBack() {
    var message = endOfData ? messages.end : messages.notEnd
    if ( window.confirm(message) ) {
      setGoBack(true)
    }
  }

  return (
    <div>
        {goBack && <Redirect to={{ pathname: '/' }}/>}
        {catchedError >= 500 && 
          <Redirect to={{ pathname: '/error', error: catchedError}}/>
        }
        <Header
          logo={ logo }
          setGoBack={ handleGoBack }
        />

        <Styled.BoxContainer>
          <h3>{ resultMessage.title }</h3>
          <hr></hr>
          { resultMessage.content.map(p => {
              return <p>
                { p }
              </p>
            }) }
        </Styled.BoxContainer>

        <Styled.ContentContainer>
          <DownloadSection
              done={ endOfData }
              results={ results }
          />

          <Table results={ results } />
          
          {fetching && !endOfData && 
            <h3>Loading more data...</h3>
          }
        </Styled.ContentContainer>
    </div>
  );
}

export default Results;
